import { Country } from 'react-phone-number-input';
import { useAppSelector } from './hook';

const FALLBACK_COUNTRY: Country = 'AE';

function toPhoneCountry(code: string | null | undefined): Country | null {
    if (!code || code.length !== 2) {
        return null;
    }

    return code.toUpperCase() as Country;
}

/**
 * Resolves the initial phone-input country flag from the visitor's public IP.
 * Avoids persisted GPS/search geo (e.g. Egypt) so VPN location is respected.
 */
export function useDefaultPhoneCountry(): Country {
    const sessionIpCountry = useAppSelector(
        (state) => state.geoLocation.sessionIpCountry
    );

    return toPhoneCountry(sessionIpCountry) ?? FALLBACK_COUNTRY;
}
